import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import ApEditorMode from '../../../enums/ApEditorMode';
import { ApTemplateType } from '../../../sic-lib/enums/ApTemplateType';
import { ApEditorActions, ApLocation } from '../../../sic-lib/reducers/actionPlanEditorReducer';
import { ApTemplate } from '../../../sic-lib/types/ApTemplate';
import { useAppSelector } from '../../../store/hooks';
import DialogModifyAsClientApTemplate from '../../Contact/Communicator/DialogModifyAsClientApTemplate/DialogModifyAsClientApTemplate';
import MenuAddApAction from '../MenuAddApAction/MenuAddApAction';

interface Props {
    contactId: number | undefined;
    apEditMode: ApEditorMode;
    apLocation: ApLocation[];
    apDispatch: React.Dispatch<ApEditorActions>;
}

export default function ApEditorTimelineToolbar({
    contactId,
    apEditMode,
    apLocation,
    apDispatch,
}: Props) {
    /* 
        TIP: this is ApScheduler-specific, ignore while editing template 
        outside of ApScheduler 
     */
    const apTemplate = useAppSelector(state => state.communicator.template);

    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = (apTemplate?: ApTemplate) => {
        if (apTemplate) {
            apDispatch({
                type: 'SET_EDITOR_PLAN',
                plan: apTemplate,
                location: apLocation,
            });
        }

        setDialogOpen(false);
    };

    return (
        <React.Fragment>
            <Grid container direction="row" alignItems="center" spacing={2}>
                <Grid item xs={true}>
                    <MenuAddApAction
                        contactId={contactId}
                        apEditMode={apEditMode}
                        apDispatch={apDispatch}
                    />
                </Grid>
                {
                    /* only "unnamed" templates can be saved, allowing them to be visible in lists */
                    apEditMode === ApEditorMode.template &&
                        apTemplate?.type === ApTemplateType.instance && (
                            <Grid item xs="auto">
                                <Button
                                    aria-haspopup={true}
                                    aria-expanded={dialogOpen}
                                    color="primary"
                                    disabled={apTemplate?.actions.length < 1}
                                    onClick={handleOpenDialog}
                                >
                                    Create Template
                                </Button>
                            </Grid>
                        )
                }
            </Grid>
            {apTemplate && dialogOpen && (
                <DialogModifyAsClientApTemplate
                    isOpen={dialogOpen}
                    onDoneHandler={handleCloseDialog}
                    apTemplate={apTemplate as ApTemplate}
                />
            )}
        </React.Fragment>
    );
}
